import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from '../../lib/trpc';
import { Button } from '../ui/Button';

/**
 * "Send it again": a new sign-up confirmation link to the person's OWN address
 * (`me.resendEmailConfirmation`, MAP 249 spec §11b). How production's existing owners, none of
 * them confirmed, confirm once email is on: the email banner offers it app-wide, and Settings →
 * Email beside the same sentence. The server refuses in words (already confirmed, three a day,
 * ServWell's confirmation emails for the day all sent), and that is what shows.
 */
export function ResendConfirmation() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  const resend = useMutation(
    trpc.me.resendEmailConfirmation.mutationOptions({
      onSuccess: () => void qc.invalidateQueries(),
    }),
  );
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        aria-disabled={resend.isPending || undefined}
        onClick={() => {
          if (!resend.isPending) resend.mutate();
        }}
      >
        {resend.isPending ? 'Sending…' : 'Send it again'}
      </Button>
      {resend.data ? (
        <span role="status" className="text-xs">
          We sent a new link to {resend.data.sentTo}.
        </span>
      ) : null}
      {resend.error ? (
        <span role="alert" className="text-xs text-[var(--sw-danger-text)]">
          {resend.error.message}
        </span>
      ) : null}
    </>
  );
}
